var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.541,
    height: 50,
    viewBox: "0 0 70.541 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marketingIcon",
    transform: "translate(-70.002 -81.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55092",
    "data-name": "Path 55092",
    d: "M557.164,244.87h-7.35a1.469,1.469,0,0,0,0,2.939h7.35a1.469,1.469,0,0,0,0-2.939Z",
    transform: "translate(-418.089 -142.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55093",
    "data-name": "Path 55093",
    d: "M549.812,180.761a1.463,1.463,0,0,0,.547-.105l.024-.008s0,0,0,0l7.319-2.928h0a1.469,1.469,0,1,0-1.091-2.727h0l-.024.011h0l-7.322,2.929h0a1.469,1.469,0,0,0,.545,2.832Z",
    transform: "translate(-418.087 -81.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55094",
    "data-name": "Path 55094",
    d: "M124.378,95.8V83a1.469,1.469,0,1,0-2.939,0v.883L94.987,91.813H78.82a1.471,1.471,0,0,0-1.468,1.47v2.939H72.943a1.471,1.471,0,0,0-1.47,1.47v2.939A1.471,1.471,0,0,0,70,102.1v2.939a1.471,1.471,0,0,0,1.47,1.47v2.94a1.469,1.469,0,0,0,1.47,1.468h4.409v2.941a1.469,1.469,0,0,0,1.468,1.468H80.9l3.8,16.2H97.925L94.259,121a1.466,1.466,0,0,0,.065-2.493l1.429-2.951,25.687,7.707v.88a1.469,1.469,0,1,0,2.939,0V111.069a8.817,8.817,0,0,0,0-15.271ZM74.411,107.979V99.162h2.941v8.818ZM80.29,94.753h14.7v17.635H80.29Zm6.741,33.836-3.111-13.26H92.6l-1.459,3.023-.532,1.1.4,1.149,2.784,7.991ZM97.925,113.14v-2.073l.028-.054h-.028V94l23.515-7.054V120.2Zm26.453-5.825V99.551a5.86,5.86,0,0,1,0,7.764Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55095",
    "data-name": "Path 55095",
    d: "M557.709,294.589l-7.319-2.93,0,0-.024-.008h0a1.47,1.47,0,0,0-1.091,2.729l7.319,2.928a.008.008,0,0,1,.006,0l.022.008v0a1.447,1.447,0,0,0,.547.108,1.469,1.469,0,0,0,.545-2.834Z",
    transform: "translate(-418.09 -183.563)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketingIcon.bc9d24535a00a511524e3671203c439c.svg";
export { ForwardRef as ReactComponent };